/**
 * Single source of truth for the fullscreen ThumbnailCarousel <NuxtImg> and the
 * modal idle warm when the carousel is open. Must stay in sync with the rendered
 * candidate URL or a warm becomes an extra download.
 */
export const THUMBNAIL_CAROUSEL_IMAGE_ATTRS = {
	width: 1280,
	sizes: 'xs:100vw sm:100vw md:60vw lg:60vw xl:60vw 2xl:960px',
	densities: 'x1',
	format: 'webp',
	quality: 80
} as const;

export const THUMBNAIL_CAROUSEL_GET_SIZES = {
	sizes: THUMBNAIL_CAROUSEL_IMAGE_ATTRS.sizes,
	densities: THUMBNAIL_CAROUSEL_IMAGE_ATTRS.densities,
	modifiers: {
		format: THUMBNAIL_CAROUSEL_IMAGE_ATTRS.format,
		width: String(THUMBNAIL_CAROUSEL_IMAGE_ATTRS.width),
		quality: String(THUMBNAIL_CAROUSEL_IMAGE_ATTRS.quality)
	}
} as const;
